import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RetryInvoiceRunMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type RetryInvoiceRunMutation = { __typename?: 'Mutation', retryInvoiceRun: { __typename?: 'InvoiceRun', id: string, status: Types.InvoiceRunStatus, due_at?: string | null, error?: string | null } };


export const RetryInvoiceRunDocument = gql`
    mutation RetryInvoiceRun($id: UUID!) {
  retryInvoiceRun(id: $id) {
    id
    status
    due_at
    error
  }
}
    `;
export type RetryInvoiceRunMutationFn = Apollo.MutationFunction<RetryInvoiceRunMutation, RetryInvoiceRunMutationVariables>;

/**
 * __useRetryInvoiceRunMutation__
 *
 * To run a mutation, you first call `useRetryInvoiceRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryInvoiceRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryInvoiceRunMutation, { data, loading, error }] = useRetryInvoiceRunMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetryInvoiceRunMutation(baseOptions?: Apollo.MutationHookOptions<RetryInvoiceRunMutation, RetryInvoiceRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryInvoiceRunMutation, RetryInvoiceRunMutationVariables>(RetryInvoiceRunDocument, options);
      }
export type RetryInvoiceRunMutationHookResult = ReturnType<typeof useRetryInvoiceRunMutation>;
export type RetryInvoiceRunMutationResult = Apollo.MutationResult<RetryInvoiceRunMutation>;
export type RetryInvoiceRunMutationOptions = Apollo.BaseMutationOptions<RetryInvoiceRunMutation, RetryInvoiceRunMutationVariables>;